import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Map } from 'immutable';
import PictionJS from 'piction-js';
import classNames from 'classnames';
import Slider from 'react-slick';
import Loader from '../ui/Loader';
import Button from '../ui/Button';
import piction from '../../utils/piction';
import { moveUmoHandler } from '../../utils/umoUtils';
import { allowDropHandler } from '../../utils/uiUtils';
import WorkspacePreviewItem from './WorkspacePreviewItem';
import { retrieveWorkspace } from '../../actions/umoGallery';
import { stringifiedToDraggable } from '../../utils/draggables';
import OptionsMenu from '../OptionsMenu';
import { SearchParams, WorkspaceTag } from '../../utils/searchUtils';

class WorkspacePreview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEnabled: true, // !!props.workspacePreview.get('selectedID'),
      isAnySelected: props.workspacePreview.get('selectedUMOIDs').size > 0 || false,
    };

    this.onClose = this.onClose.bind(this);
    this.onNextPageClick = this.onNextPageClick.bind(this);
    this.onPrevPageClick = this.onPrevPageClick.bind(this);
    // this.onOptionsSelect = this.onOptionsSelect.bind(this);
    this.onDetailsClick = this.onDetailsClick.bind(this);
    this.onUmoItemsDrop = this.onUmoItemsDrop.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.workspacePreview !== this.props.workspacePreview ||
      nextProps.isWorkspaceExpanded !== this.props.isWorkspaceExpanded ||
      nextProps.intl.locale !== this.props.intl.locale;
  }

  componentDidUpdate(prevProps) {
    // added to fix a slick-slider bug- when re-expanding the workspace preview after collapsing it,
    // the slider would only display the last item, and have all the other ones with width:0
    // so triggering a resize to make slick re-render
    if (prevProps.isWorkspaceExpanded !== this.props.isWorkspaceExpanded
      && this.props.isWorkspaceExpanded) {
      setTimeout(() => window.dispatchEvent(new Event('resize')), 0);
    }
  }

  onClose() {
    this.props.onWorkspaceToggle(false);
  }

  onNextPageClick() {
    this.sliderRef.slickNext();
  }

  onPrevPageClick() {
    this.sliderRef.slickPrev();
  }

  onDetailsClick() {
    const id = this.props.workspacePreview.get('selectedID');
    const name = this.props.workspacePreview.getIn(['selectedData', 'name']);
    const description = this.props.workspacePreview.getIn(['selectedData', 'description']);

    this.props.dispatch(retrieveWorkspace(
      id,
      name,
      description
    ));
  }

  onUmoItemsDrop(e) {
    e.preventDefault();

    const draggable = stringifiedToDraggable(e.dataTransfer.getData('text'));
    if (!(draggable instanceof Error) && this.props.workspacePreview.get('selectedID')) {
      const origin = {
        id: draggable.originData.workspaceID,
        isWorkspace: draggable.isWorkspaceItem(),
      };
      const target = {
        id: this.props.workspacePreview.get('selectedID'),
        isWorkspace: true,
      };
      moveUmoHandler(origin, target, draggable.getSelectionList(), this.props.dispatch,
        draggable.getIsSelectAll() ? draggable.getSearchParams() : null);
    }
  }

  render() {
    const { intl } = this.props;
    const sliderSettings = {
      draggable: false,
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 8,
      slidesToScroll: 8,
      initialSlide: 0,
      swipeToSlide: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    const workspaceID = this.props.workspacePreview.get('selectedID');
    const workspaceData = this.props.workspacePreview.get('selectedData').toJS();

    return (
      <div
        className={classNames('workspace-preview', {
          'workspace-preview--open': this.props.isWorkspaceExpanded }
        )}
        onDrop={this.onUmoItemsDrop}
        onDragOver={allowDropHandler}
      >

        {this.props.workspacePreview.get('isRequesting') ?
          <Loader className="workspace-preview__loader" isLarge /> :
          <div>
            <div className="workspace-preview__details">
              <Button
                disabled={!this.state.isEnabled}
                variant="primary"
                className="workspace-preview__details-button"
                onClick={this.onDetailsClick}
              >
                {intl.formatMessage({ id: 'workspacePreview.workspaceDetailsButton' })}
              </Button>
            </div>

            <div className="workspace-preview__slider">
              <div
                onClick={this.onPrevPageClick}
                className="workspace-preview__slider-arrow workspace-preview__slider-arrow-left"
              >
                <i className="workspace-preview__slider-arrow-left-icon" />
              </div>

              <div className="workspace-preview__slider-images">
                {
                  this.props.workspacePreview.get('umoList').size > 0 ?
                    <Slider {...sliderSettings} ref={(ref) => { this.sliderRef = ref; }}>
                      {
                        this.props.workspacePreview.get('umoList').map((umoData, i) =>
                          <div key={i}>
                            <WorkspacePreviewItem
                              umo={new PictionJS.UMO(umoData.toJS(), { hostURL: piction.hostURL })}
                              selectedWorkspaceData={{
                                id: workspaceID,
                                ...workspaceData,
                              }}
                              isSelected={
                                this.props.workspacePreview
                                  .get('selectedUMOIDs').indexOf(umoData.getIn(['id', 0])) > -1 ||
                                this.props.workspacePreview.get('isSelectAll')
                              }
                              dispatch={this.props.dispatch}
                            />
                          </div>
                        )
                      }
                    </Slider>
                    :
                    null
                }
              </div>
              <div
                onClick={this.onNextPageClick}
                className="workspace-preview__slider-arrow workspace-preview__slider-arrow-right"
              >
                <i className="workspace-preview__slider-arrow-right-icon" />
              </div>
            </div>

            <div className="workspace-preview__action">
              <OptionsMenu
                dispatch={this.props.dispatch}
                selectedUMOIDs={this.props.workspacePreview.get('selectedUMOIDs')}
                selectedWorkspaceData={{
                  id: workspaceID,
                  ...workspaceData,
                }}
                umoList={this.props.workspacePreview.get('umoList')}
                isPinnedWorkspace
                isUMOGalleryWorkspace
                searchParams={workspaceID ?
                  new SearchParams({
                    searchQuery: null,
                    tagList: [new WorkspaceTag(
                      workspaceID, workspaceData.name, workspaceData.description)],
                    metadataList: null,
                    filterByList: null,
                    typeFilter: null,
                  }) : null}
                isSelectAll={this.props.workspacePreview.get('isSelectAll')}
                disabled={!this.state.isEnabled}
                title={intl.formatMessage({ id: 'workspacePreview.options' })}
                className="workspace-preview__action-button"
                id="user-dropdown"
              />
            </div>
          </div>
        }
      </div>
    );
  }
}

WorkspacePreview.propTypes = {
  workspacePreview: PropTypes.instanceOf(Map),
  onWorkspaceToggle: PropTypes.func,
  isWorkspaceExpanded: PropTypes.bool,
  dispatch: PropTypes.func,
};

export default injectIntl(WorkspacePreview);



// WEBPACK FOOTER //
// ./src/js/components/WorkspacePreview/index.jsx